import { Injectable } from '@angular/core';
import { HubEntityType } from '@core/interfaces/hub-entity-type';
import { ResultOfMainSearch } from '@core/interfaces/main-search';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MainSearchStoreService {
  private readonly resultsOfSearch$: BehaviorSubject<ResultOfMainSearch[]> = new BehaviorSubject<
    ResultOfMainSearch[]
  >([]);

  readonly searchResults$ = this.resultsOfSearch$.asObservable();

  readonly projectsResults$ = this.searchResults$.pipe(
    map((results) => results.filter((result) => result.data.type === HubEntityType.Project)),
  );

  readonly contractsResults$ = this.searchResults$.pipe(
    map((results) => results.filter((result) => result.data.type === HubEntityType.Contract)),
  );

  readonly methodsResults$ = this.searchResults$.pipe(
    map((results) => results.filter((result) => result.data.type === HubEntityType.Method)),
  );

  readonly assetsResults$ = this.searchResults$.pipe(
    map((results) => results.filter((result) => result.data.type === HubEntityType.Asset)),
  );

  readonly modulesResults$ = this.searchResults$.pipe(
    map((results) => results.filter((result) => result.data.type === HubEntityType.Module)),
  );

  setState(value: ResultOfMainSearch[]): void {
    this.resultsOfSearch$.next(value);
  }
}
